import { useOpenNodeContextMenu } from "@/pages/canvas/hooks/useOpenNodeContextMenu";
import { useNodeId } from "@xyflow/react";
import { MoreHorizontal } from "lucide-react";
import { CanvasToolbarButton } from "../../components/toolbar";

interface NodeToolbarContextMenuButtonProps {
  /** Override the node id; defaults to the enclosing node via `useNodeId`. */
  nodeId?: string;
  tooltipSide?: "top" | "right" | "bottom" | "left";
}

/**
 * Default three-dot button for canvas node toolbars. Opens the same menu as
 * the node's right-click context menu, so toolbar and right-click stay in sync.
 */
export function NodeToolbarContextMenuButton({
  nodeId: nodeIdProp,
  tooltipSide = "top",
}: NodeToolbarContextMenuButtonProps) {
  const contextNodeId = useNodeId();
  const nodeId = nodeIdProp ?? contextNodeId ?? undefined;
  const openContextMenu = useOpenNodeContextMenu();

  if (!nodeId) {
    return null;
  }

  return (
    <CanvasToolbarButton
      label="More"
      tooltipSide={tooltipSide}
      onClick={(e) => {
        e.stopPropagation();
        openContextMenu(nodeId, e.currentTarget);
      }}
    >
      <MoreHorizontal className="size-4" />
    </CanvasToolbarButton>
  );
}
